"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectTypeEnum = void 0;
var SubjectTypeEnum;
(function (SubjectTypeEnum) {
    SubjectTypeEnum["BIBLE"] = "BIBLE";
    SubjectTypeEnum["ELECTIVES"] = "ELECTIVES";
    SubjectTypeEnum["ELECTIVES_CAREER_COURSES"] = "ELECTIVES_CAREER_COURSES";
    SubjectTypeEnum["ELECTIVES_STATE_HISTORY"] = "ELECTIVES_STATE_HISTORY";
    SubjectTypeEnum["HISTORY_AND_GEOGRAPHY"] = "HISTORY_AND_GEOGRAPHY";
    SubjectTypeEnum["LANGUAGE_ARTS"] = "LANGUAGE_ARTS";
    SubjectTypeEnum["MATH"] = "MATH";
    SubjectTypeEnum["OTHER"] = "OTHER";
    SubjectTypeEnum["SCIENCE"] = "SCIENCE";
})(SubjectTypeEnum || (exports.SubjectTypeEnum = SubjectTypeEnum = {}));
